<template>
    <v-container fluid px-0>
        <v-layout row class="common-card">
                <v-flex xs3 md2 class="star">
                    <v-icon color="#3E67FB" size="28">assignment</v-icon>
                    <span class="ml-3 font-weight-bold blue-title title">Result</span>
                </v-flex>
                <v-flex xs9 md10  class="box">
                    <!-- <div class="scoreBtn ma-0 pa-0">
                            <v-btn class="btns text-none" 
                            :id="info.LessonScore?parseInt(info.LessonScore)-2==i?'enter-score-sure':'':''" 
                            color="grey lighten-1" 
                            v-for="(item,i) in scoreList" 
                            :key="i" 
                            @mouseenter="enter($event,i)" 
                            @mouseleave="leave($event)" 
                            @click="comfirmScore(i+2)" 
                            :disabled="isChoose || info.LessonScore">{{item}}</v-btn>
                    </div>
                        <v-flex v-for="(item,index) in groupOne" :key="index">
                            <div class="rules" @mouseenter="enterRules(index)" @mouseleave="leaveRules()"  v-if="rulesIndex==index">
                                <div class="pt-3">
                                    <p class="pl-2 pb-2">{{item}}</p>
                                </div>
                            </div>
                        </v-flex> -->

                    <div class="scoreBtn">
                        <v-tooltip bottom content-class="common-tooltip" v-for="(item,i) in scoreList" :key="i" >
                            <template v-slot:activator="{ on }">
                            <v-btn 
                                v-on="on"
                                @mouseover="rulesIndex=i" 
                                @mouseout="rulesIndex=-1" 
                                @click="comfirmScore(item.score,i)" 
                                class="text-none btns"
                                :class="{'enter-score':rulesIndex==i}"
                                :id="info.LessonScore?parseInt(info.LessonScore)-2==i?'id-score-sure':'':''" 
                                :disabled="isChoose || info.LessonScore">{{item.score}}</v-btn>
                            </template>
                            <span>{{item.desc}}</span>
                        </v-tooltip>
                    </div>
                </v-flex>
        </v-layout>
    </v-container>
    
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const namespace = 'classDetail'
const { mapGetters } = createNamespacedHelpers(namespace)
import {  EditLessonScore } from '../../api/classtable'
export default {
    data:()=>({
        rulesIndex:-1,
        isChoose:false,
        oneOfLi:null,
        scoreList:[
            {
                score:'Failed',
                desc:'If the child cannot answer any questions and cannot read after the teacher. There is no interaction during the whole class'
            },
            {
                score:'General',
                desc:'Cannot answer any questions. but can follow up the teacher'
            },
            {
                score:'Good',
                desc:'Can answer 70% of the questions'
            },
            {
                score:'Excellent',
                desc:'Ability to actively interact with foreign teachers and answer more than 90% of questions'
            }
        ]
    }),
    computed: {
        ...mapGetters(['info'])
    },
    methods:{
        comfirmScore(score,i){
            let lis = document.querySelectorAll(".btns");
            if(this.info.IsOverClass){
                this.$root
                .$confirm(
                `The exam result can not be changed after confirmation`,
                'default',
                { 
                    awaitSubmit: true,
                    width:470
                })
                .then(({ result, submitcomplete }) => {
                    if (result) {
                        submitcomplete();
                        this.isChoose = true;
                        this.rulesIndex = i;
                        lis[i].setAttribute('id','id-score-sure');
                        EditLessonScore(this.info.CLID,score,2)
                    }
                })
            }else{
                this.$root
                .$confirm(
                `Please fill in 25 minutes after the start of the course`,
                'default',
                { 
                    width:470
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .star{
        vertical-align: middle;
    }
    .star .v-icon{
        position: relative;
        top: 4px;
    }
    .star span{
        font-size: 28px;
    }
    .box{
        position: relative;
    }
    .box .scoreBtn{
        overflow: hidden;
    }
    .box .scoreBtn .v-btn{
        width: 70px;
        height: 28px;
        background-color: rgba(224, 224, 224, 0.5);
        color:$blue-title;
        margin-right: 32px;
        font-size: 16px;
        font-weight: 700;
        box-shadow: none;
        border-radius:4px
    }
    .enter-score,#id-score-sure{
        color: #fff !important;
        background-color: #3e67fb !important;
    }
    .star{
        i{
            color:#3E67FB;
            position:relative;
            top:6px;
        }
        .v-btn{
            height:28px
        }
    }
    .common-tooltip{
        &:after{
            border-width:0
        }
    }
    /* .box .rules{
        position: absolute;
        top: 40px;
        width: 796px;
        padding-top: 30px;
        z-index: 999;
    } */
    /* .box .rules>div{
        background-color: #fff;
        box-shadow: 0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)!important;
    } */
</style>